import React from "react";
import {View} from "@unibuddy/patron";
import {useBooleanFeatureFlag} from "ub-feature-flagging-react";

import {SHOW_INTERSTITIAL_PAGE_HEADER} from "shared/constants";
import {IntroPageCardsContainer} from "../components/IntroPageCardsContainer";
import {IntroPageHeader} from "../components/IntroPageHeader";

export function IntroPage({
    setUserHasSeenIntroPage,
}: {
    setUserHasSeenIntroPage: (b: boolean) => void;
}) {
    const showIntroPageHeader = useBooleanFeatureFlag(
        SHOW_INTERSTITIAL_PAGE_HEADER.key,
        SHOW_INTERSTITIAL_PAGE_HEADER.value,
    );

    return (
        <View gap="large" paddingY={["medium", "large", "xlarge"]}>
            {showIntroPageHeader ? <IntroPageHeader /> : null}
            <IntroPageCardsContainer setUserHasSeenIntroPage={setUserHasSeenIntroPage} />
        </View>
    );
}
